import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./utils/analytics";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const body = document.querySelector('#root');
    body.scrollIntoView({
        behavior: 'smooth'
    }, 500);

    // Track page view for route changes
    if (pathname) {
      trackPageView(pathname, document.title).catch((error) => {
        console.error("Error tracking page view:", error);
      });
    }
  }, [pathname]);

  return null;
}